import { render, staticRenderFns } from "./BoNavGroup.vue?vue&type=template&id=715311be&scoped=true&"
import script from "./BoNavGroup.vue?vue&type=script&lang=js&"
export * from "./BoNavGroup.vue?vue&type=script&lang=js&"
import style0 from "./BoNavGroup.vue?vue&type=style&index=0&id=715311be&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "715311be",
  null
  
)

export default component.exports